// Utility to convert numbers to French text for invoice PDFs
export const numberToFrenchText = (number) => {
  if (number === 0) return 'zéro';
  
  const units = ['', 'un', 'deux', 'trois', 'quatre', 'cinq', 'six', 'sept', 'huit', 'neuf'];
  const teens = ['dix', 'onze', 'douze', 'treize', 'quatorze', 'quinze', 'seize', 'dix-sept', 'dix-huit', 'dix-neuf'];
  const tens = ['', '', 'vingt', 'trente', 'quarante', 'cinquante', 'soixante', 'soixante-dix', 'quatre-vingt', 'quatre-vingt-dix'];
  
  const convertLessThanOneThousand = (num) => {
    if (num === 0) return '';
    
    if (num < 10) return units[num];
    
    if (num < 20) return teens[num - 10];
    
    if (num < 100) {
      if (num % 10 === 0) return tens[Math.floor(num / 10)];
      if (num < 70) return tens[Math.floor(num / 10)] + '-' + units[num % 10];
      if (num < 80) return 'soixante-' + teens[num - 60];
      return 'quatre-vingt-' + units[num % 10];
    }
    
    if (num < 1000) {
      const hundreds = Math.floor(num / 100);
      const remainder = num % 100;
      let result = '';
      
      if (hundreds === 1) {
        result = 'cent';
      } else {
        result = units[hundreds] + ' cent';
      }
      
      if (remainder > 0) {
        result += ' ' + convertLessThanOneThousand(remainder);
      }
      
      return result;
    }
    
    return '';
  };
  
  const convert = (num) => {
    if (num === 0) return 'zéro';
    
    const billions = Math.floor(num / 1000000000);
    const millions = Math.floor((num % 1000000000) / 1000000);
    const thousands = Math.floor((num % 1000000) / 1000);
    const remainder = num % 1000;
    
    let result = '';
    
    if (billions > 0) {
      if (billions === 1) {
        result += 'un milliard';
      } else {
        result += convertLessThanOneThousand(billions) + ' milliards';
      }
    }
    
    if (millions > 0) {
      if (result) result += ' ';
      if (millions === 1) {
        result += 'un million';
      } else {
        result += convertLessThanOneThousand(millions) + ' millions';
      }
    }
    
    if (thousands > 0) {
      if (result) result += ' ';
      if (thousands === 1) {
        result += 'mille';
      } else {
        result += convertLessThanOneThousand(thousands) + ' mille';
      }
    }
    
    if (remainder > 0) {
      if (result) result += ' ';
      result += convertLessThanOneThousand(remainder);
    }
    
    return result;
  };
  
  // Handle decimal numbers
  const integerPart = Math.floor(number);
  const decimalPart = Math.round((number - integerPart) * 100);
  
  let result = convert(integerPart);
  
  if (decimalPart > 0) {
    result += ' et ' + convert(decimalPart) + ' centimes';
  }
  
  return result;
};

// Format payment method in French
export const formatPaymentMethod = (payments) => {
  if (!payments || payments.length === 0) return 'Espèce';
  
  const paymentModes = [...new Set(payments.map(p => p.mode))];
  const paymentLabels = {
    'espece': 'Espèce',
    'cheque': 'Chèque',
    'carte_bancaire': 'Carte bancaire',
    'virement': 'Virement bancaire',
    'traite': 'Traite',
    'effet': 'Effet de commerce'
  };
  
  if (paymentModes.length === 1) {
    return paymentLabels[paymentModes[0]] || 'Espèce';
  }
  
  return paymentModes.map(mode => paymentLabels[mode] || mode).join(', ');
};
